import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../utils/hooks/useMutationWithError";
import {
  CreateSingleSlotBookingsInput,
  useCreateNewGolfBookingMutation,
  useCreateNewGolfBookingMutation$data,
} from "./__generated__/useCreateNewGolfBookingMutation.graphql";

export const useCreateNewGolfBooking = () => {
  const [createNewGolfBooking, isCreating] =
    useMutationWithError<useCreateNewGolfBookingMutation>(
      useCreateNewGolfBookingMutationString
    );

  const handleCreateNewGolfBooking = (
    input: CreateSingleSlotBookingsInput,
    onComplete: (bookingId: string) => void
  ) => {
    createNewGolfBooking({
      variables: { input },
      onCompleted: (res: useCreateNewGolfBookingMutation$data) => {
        const bookingId = res.responsePayload?.bookings?.find(
          (booking) => booking?.id
        )?.id;
        if (bookingId) {
          onComplete(bookingId);
        }
      },
    });
  };

  return [handleCreateNewGolfBooking, isCreating] as const;
};

const useCreateNewGolfBookingMutationString = graphql`
  mutation useCreateNewGolfBookingMutation(
    $input: CreateSingleSlotBookingsInput!
  ) {
    responsePayload: createSingleSlotBookings(input: $input) {
      errors {
        field
        code
        message
      }
      success
      bookings {
        id
      }
      startSlots {
        id
        ...TeeSheetAgendaConsistency_timeSlot
      }
    }
  }
`;
